import { useEffect, useRef, useState } from 'react';
import { Box, Dialog, InputAdornment, TextField, Typography, useTheme } from '@mui/material';

import CommonButton from '../CommonButton';
import CommonModal from './CommonModal';
import { useWeb3 } from '@/hooks/use-web3';
import {
  CALCULATEPENDINGREWARDFORALLSTAKES,
  CLAIMALLREWARD,
  GETTOTALSTAKEDAMOUNT,
  PoolState,
  STATE,
} from '@/lib/common/name-space';
import { isCompleteModalType } from '@/types';
import SymbolSvg from '@/assets/assetfi/Symbol';
import CloseSvg from '@/assets/assetfi/Close';

interface ClaimModalPropsType {
  handleClose: () => void;
  open: boolean;
  contractAddr: string;
}

const ClaimModal = ({ handleClose, open, contractAddr }: ClaimModalPropsType) => {
  const detail = useRef('');

  // state
  const [isCompleteModal, setIsCompleteModal] = useState<isCompleteModalType>({
    success: false,
    fail: false,
  });
  const address = useRef('');
  const amt = useRef({
    stake: '0',
    reward: '0',
  });

  const theme = useTheme();
  const { web3authCall } = useWeb3();

  useEffect(() => {
    if (open && web3authCall?.connected() && contractAddr) {
      (async () => {
        const addr = await web3authCall.getAddress();
        address.current = addr;
        detail.current = await setDetail();
        // 사용자가 스테이킹한 금액
        const stakeAmt = await web3authCall.callStaking(GETTOTALSTAKEDAMOUNT, contractAddr, [addr]);
        amt.current.stake = stakeAmt;
        // 리워드 전체 금액
        // 모금 기간에 호출 불가
        if (
          detail.current === PoolState.POOLSTATE_OPERATING ||
          detail.current === PoolState.POOLSTATE_OPERATING_CLOSED ||
          detail.current === PoolState.POOLSTATE_OPERATING_STOPPED
        ) {
          const rewardAmt = await web3authCall.callStaking(CALCULATEPENDINGREWARDFORALLSTAKES, contractAddr, [addr]);
          amt.current.reward = rewardAmt;
        }
      })();
    }

    return () => {};
  }, [web3authCall, contractAddr, open]);

  // method
  const handleConfirm = async () => {
    await claimAllReward();
    handleClose();
  };
  const claimAllReward = async () => {
    const { code } = await web3authCall!.callStaking(CLAIMALLREWARD, contractAddr, [address.current]);
    if (code !== 200) {
      triggerIsCompleteModal('fail');
    } else {
      triggerIsCompleteModal('success');
    }
  };
  const triggerIsCompleteModal = (key: keyof isCompleteModalType) => {
    setIsCompleteModal((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };
  const setDetail = async (): Promise<string> => {
    return await web3authCall?.callStaking(STATE, contractAddr);
  };
  // TODO
  // 시세 가져오기

  return (
    <>
      <Dialog
        sx={{
          '& .MuiDialog-paper': {
            width: '320px',
            padding: '24px 0px',
            borderRadius: '20px',
          },
        }}
        open={open}
      >
        <Box
          sx={{
            display: 'flex',
            gap: '10px',
            justifyContent: 'space-between',
            padding: '0px 24px',
          }}
        >
          <SymbolSvg width={24} height={24} />
          <Typography color={theme.greyscale.darkgrey2} variant="h6">
            RWA Staking Hupayx No.1
          </Typography>

          <Box onClick={handleClose} sx={{ cursor: 'pointer' }}>
            <CloseSvg width={24} height={24} />
          </Box>
        </Box>

        <Box sx={{ marginTop: '24px', padding: '0px 16px', position: 'relative' }}>
          <Typography sx={{ marginLeft: '8px' }} variant="subtitle2" color={theme.greyscale.grey3}>
            Stake Amount
          </Typography>

          <Typography
            sx={{ position: 'absolute', right: 24, bottom: 28 }}
            color={theme.greyscale.grey3}
            variant="body2"
          >
            ~ 0 USD
          </Typography>
          <TextField
            value={amt.current.stake}
            disabled
            sx={{
              width: '100%',
              marginTop: '8px',

              '& .MuiOutlinedInput-root': {
                borderRadius: '10px',
                '& input': {
                  textAlign: 'right',
                  typography: 'h4',
                  color: theme.greyscale.darkgrey2,
                  padding: '8px',
                  paddingRight: '0px',
                  paddingBottom: '28px',
                },
                '& fieldset': {
                  borderColor: theme.background.blue,
                },
                '&:hover fieldset': {
                  borderColor: theme.background.blue,
                },
                '&.Mui-focused fieldset': {
                  borderColor: theme.background.blue,
                },
                '&.MuiInputBase-root': {
                  background: '#357AFF1A',
                  padding: 0,
                },
                '& .MuiTypography-root': {
                  typography: 'h5',
                  color: theme.greyscale.darkgrey2,
                },
              },
            }}
            variant="outlined"
            InputProps={{
              endAdornment: (
                <InputAdornment
                  sx={{
                    fontSize: '24px',
                    paddingRight: '8px',
                    paddingBottom: '20px',
                  }}
                  position="end"
                >
                  SFL
                </InputAdornment>
              ),
            }}
          />
          <Typography sx={{ marginRight: '8px' }} align="right" variant="subtitle2" color={theme.greyscale.grey3}>
            Balance ~ 20,953 USD
          </Typography>
        </Box>

        <Box sx={{ marginTop: '24px', padding: '0px 16px' }}>
          <Typography sx={{ marginLeft: '8px' }} variant="subtitle2" color={theme.greyscale.grey3}>
            Details
          </Typography>

          <Box
            sx={{
              marginTop: '8px',
              background: theme.background.default,
              borderRadius: '10px',
              border: `0.5px solid ${theme.greyscale.grey1}`,
            }}
          >
            {/* <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '8px',
                borderBottom: `0.5px solid ${theme.greyscale.lightgrey2}`,
              }}
            >
              <Typography variant="body2" color={theme.greyscale.grey1}>
                No.
              </Typography>

              <Box sx={{ textAlign: 'right' }}>
                <Typography variant="subtitle2" color={theme.greyscale.darkgrey2}>
                  1
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '8px',
                borderBottom: `0.5px solid ${theme.greyscale.lightgrey2}`,
              }}
            >
              <Typography variant="body2" color={theme.greyscale.grey1}>
                Stake Amount
              </Typography>

              <Box sx={{ textAlign: 'right' }}>
                <Typography variant="subtitle2" color={theme.greyscale.darkgrey2}>
                  1,000,000{' '}
                  <Typography display={'inline'} variant="body4" color={theme.greyscale.darkgrey2}>
                    USD
                  </Typography>
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '8px',
                borderBottom: `0.5px solid ${theme.greyscale.lightgrey2}`,
              }}
            >
              <Typography variant="body2" color={theme.greyscale.grey1}>
                APR
              </Typography>

              <Box sx={{ textAlign: 'right' }}>
                <Typography variant="subtitle2" color={theme.greyscale.darkgrey2}>
                  10.0%
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '8px',
                borderBottom: `0.5px solid ${theme.greyscale.lightgrey2}`,
              }}
            >
              <Typography variant="body2" color={theme.greyscale.grey1}>
                Pool End
              </Typography>

              <Box sx={{ textAlign: 'right' }}>
                <Typography variant="subtitle2" color={theme.greyscale.darkgrey2}>
                  MM-DD-YYYY 00:00
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '8px',
                borderBottom: `0.5px solid ${theme.greyscale.lightgrey2}`,
              }}
            >
              <Typography variant="body2" color={theme.greyscale.grey1}>
                Payment Date
              </Typography>

              <Box sx={{ textAlign: 'right' }}>
                <Typography variant="subtitle2" color={theme.greyscale.darkgrey2}>
                  MM-DD-YYYY 00:00
                </Typography>
              </Box>
            </Box> */}

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '8px',
              }}
            >
              <Typography variant="body2" color={theme.greyscale.grey1}>
                Rewards
              </Typography>

              <Box sx={{ textAlign: 'right' }}>
                <Typography variant="subtitle2" color={theme.greyscale.darkgrey2}>
                  {amt.current.reward} SFL
                  {/* 1,000 USD */}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            marginTop: '24px',
            padding: '0px 16px',
            paddingTop: '24px',
            borderTop: `0.5px solid ${theme.greyscale.lightgrey2}`,
          }}
        >
          <CommonButton
            sx={{ width: '100%', padding: '12px 20px', borderRadius: '10px' }}
            text="Claim"
            handleClick={handleConfirm}
            variant="h6"
            color={'#ffffff'}
            bgColor={theme.background.blue}
            border={theme.background.blue}
          />
          <CommonButton
            sx={{
              width: '100%',
              padding: '12px 20px',
              borderRadius: '10px',
              marginTop: '10px',
            }}
            text="Back"
            handleClick={handleClose}
            variant="h6"
            color={theme.greyscale.lightgrey2}
            border={theme.greyscale.lightgrey2}
            bgColor={'#ffffff'}
          />
        </Box>
      </Dialog>

      {/*  Claim 성공 시 */}
      <CommonModal
        open={isCompleteModal.success}
        handleClose={() => {
          triggerIsCompleteModal('success');
        }}
        title="Claim Complete"
        type="success"
      >
        <Typography color={theme.greyscale.grey2} variant="h6">
          Claim Completed Successfully.
          <br />
          Thank You.
        </Typography>
      </CommonModal>

      {/*  Claim 실패 시 */}
      <CommonModal
        open={isCompleteModal.fail}
        handleClose={() => {
          triggerIsCompleteModal('fail');
        }}
        title="Error"
        type="error"
      >
        <Typography color={theme.greyscale.grey2} variant="h6">
          Claim Failed.
        </Typography>
      </CommonModal>
    </>
  );
};

export default ClaimModal;
